import { Text } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';
import { Emoji } from '@/imports/ui/chakra/components/Emoji';
import { Semibold } from '@/imports/ui/chakra/components/Semibold';

type TierCardProps = {
  organizationName: string;
  tierName: string;
};

export const TierCard: React.FC<TierCardProps> = (props) => {
  return (
    <Card p="6">
      <Emoji fontSize="3xl" label="star" symbol="🌟" />
      <Text>
        {props.organizationName} is a{' '}
        <Semibold textTransform="capitalize">
          {props.tierName.toLowerCase()} Sponsor
        </Semibold>
      </Text>
    </Card>
  );
};
